export default __webpack_public_path__ + "static/media/loading.4c78f5ae.svg";